/**
 * API Page Layout
 *
 * Shared layout component for API-related pages to ensure consistent styling and structure
 */

import React from 'react'
import { useRouter } from 'next/navigation'
import { IconArrowLeft } from '@tabler/icons-react'
import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import ApiNavigation from './ApiNavigation'

interface ApiPageLayoutProps {
  title: string
  children: React.ReactNode
  actions?: React.ReactNode
  showNavigation?: boolean
}

export default function ApiPageLayout({
  title,
  children,
  actions,
  showNavigation = true
}: ApiPageLayoutProps) {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <div className="container mx-auto max-w-screen-xl px-4 py-8 sm:px-6">
      <div className="mb-6 flex flex-col items-start justify-between md:flex-row md:items-center">
        <div className="mb-4 flex items-center md:mb-0">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => router.push('/')}
            className="mr-2"
            aria-label={t('Back')}
          >
            <IconArrowLeft size={20} />
          </Button>
          <h1 className="text-2xl font-bold">{title}</h1>
        </div>

        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>

      {showNavigation && <ApiNavigation />}

      {children}
    </div>
  )
}
